export default __webpack_public_path__ + "static/media/head01_en_pc.144e845a.png";